/**
 * Migration utility to re-extract elements for existing templates in Supabase
 * Run this once to populate extracted_elements for templates that were saved before the feature was added
 */
import { getDocumentTemplates, updateDocumentTemplate, extractTemplateElements } from './supabase-documents';
export async function migrateTemplateElements(forceRemigrate = false) {
    console.log('Starting template elements migration...');
    console.log('Force re-migrate:', forceRemigrate);
    try {
        // Get all templates
        const templates = await getDocumentTemplates();
        console.log(`Found ${templates.length} templates to migrate`);
        let migrated = 0;
        let skipped = 0;
        for (const template of templates) {
            // Check if template already has extracted_elements
            if (!forceRemigrate && template.extracted_elements && Object.keys(template.extracted_elements).length > 0) {
                console.log(`Skipping ${template.name} - already has extracted elements`);
                skipped++;
                continue;
            }
            console.log(`Migrating ${template.name}...`);
            // Extract elements from template content
            const extractedElements = extractTemplateElements(template.template_content);
            console.log(`  - Variables: ${extractedElements.variables.length}`);
            console.log(`  - Placeholders: ${extractedElements.placeholders.length}`);
            console.log(`  - Conditionals: ${extractedElements.conditionals.length}`);
            console.log(`  - Cross-references: ${extractedElements.crossReferences.length}`);
            // Update template with extracted elements
            await updateDocumentTemplate(template.id, {
                extracted_elements: extractedElements
            });
            migrated++;
        }
        console.log(`Migration complete! Migrated: ${migrated}, Skipped: ${skipped}`);
        return { migrated, skipped, total: templates.length };
    }
    catch (error) {
        console.error('Migration failed:', error);
        throw error;
    }
}
// Export for use in browser console
if (typeof window !== 'undefined') {
    window.migrateTemplateElements = migrateTemplateElements;
}
